import type { CrossJoinTargetProduct } from '../../common/types';
import type { AccessRequestCapabilityResponse, AccessRequestCapabilityType } from '../types';

export const getAccessRequestCapability = async (
	product: CrossJoinTargetProduct,
	cloudId: string,
): Promise<AccessRequestCapabilityType> => {
	const resource = `ari:cloud:${product}::site/${cloudId}`;
	const params = new URLSearchParams({
		resource,
	});
	const response = await fetch(
		`/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		},
	);
	const capabilities = ((await response.json()) as unknown as AccessRequestCapabilityResponse)
		?.results[resource];

	return capabilities;
};
